import us from '../../defines';
import { roundToDecimals } from '../../lib/utility/helpers';
import { createLogger } from '../../../../shared/services/logger';

const logger = createLogger('ZoomSliderControl');

export default function ZoomSliderControl (viewport, userPrefs, zoomContainer) {
  var self = this;
  var isLoaded = false; // zoom slider has been loaded
  let isActive = false; // Zoom slider is being used to set zoom

  var jZoomSliderDiv;

  var navModesImHiddenIn = {}; // what navigation modes not to display the zoom slider control

  // ............................................ construct_ local
  var construct_ = function () {
    if (!us.ENABLEZOOMSLIDER || !zoomContainer) {
      if (!zoomContainer) {
        logger.warn('zoomContainer is not present.');
      }
      return;
    }

    navModesImHiddenIn[us.eNavModes.nmRasterScan] = true; // hide zoom slider in rasterscan mode
    us.setAnnotNavModes(navModesImHiddenIn); // hide zoom slider when drawing any annotation

    load_(); // load the zoom slider
  };
    // ............................................ show() public
  this.show = function (show) {
    if (!isLoaded) {
      return;
    }

    // prevent show if preference is not to show
    if (!userPrefs[us.clsDIVZOOMSLIDER]) {
      jZoomSliderDiv.hide();
    } else if (show) {
      jZoomSliderDiv.show();
    } else {
      jZoomSliderDiv.hide();
    }
  };

  // ............................................ enable() public
  //    This function enables the zoom slider control which is disabled when the slider stops
  //    to prevent slider changes while image is being resolved.
  this.enable = function () {
    if (!isLoaded) {
      return;
    }
    if (jZoomSliderDiv.is(':visible')) {
      jZoomSliderDiv.slider('enable');
    }
  };

  // ............................................ load_() local
  //    This function builds the zoom slider control and calls into the layout manager
  //         to position it according to its layout settings.
  //    Note that the sizing of the slider uses the fixed zoom control so it must be created first.
  //    Note that the bottom of the slider is value 0 and the top is its max value.
  //
  //    references:
  //        http://jqueryui.com/demos/slider/#slider-vertical
  var load_ = function () {
    if (jZoomSliderDiv) {
      // if this viewport already has a zoom slider, return
      return;
    }

    // first create an offscreen div that will contain the zoom slider
    jZoomSliderDiv = $('<div/>', { // build the div tag that contains the zoom slider
      'class': us.clsDIVZOOMSLIDER + ' ' + us.clsOVERLAY // overlay class sets the z-index
    });

    jZoomSliderDiv.slider({ // create the slider associated with this div
      orientation: 'vertical',
      range: 'min',
      min: us.zoomSpecs.sliderMin,
      max: us.zoomSpecs.sliderMax,
      value: 0,
      slide: function (event, ui) { // catch the slide event only to update the handle's text
        var jHandle = $(ui.handle);
        var maxVal = $(this).slider('option', 'max');
        var value = $(this).slider('value');
        var zoom = sliderValToZoom_(maxVal, value);
        zoom = roundToDecimals(zoom); // keep zoom in proper resolution
        if (zoom !== viewport.getViewZoom()) {
          isActive = true;
          var mag = viewport.getBaseMag() / zoom;
          mag = mag.toFixed(1);
          jHandle.text(mag + 'x');
          viewport.zoomAbsolute(zoom); // execute the zoom
        }
      },
      stop: function (event, ui) { // catch the stop event to zoom the view
        viewport.zoomAbsolute(viewport.getViewZoom());
        isActive = false;
      }
    });

    var hWidth = 45; // desired handle width is the width of the fixed zoom control
    var barWidth = Math.max(jZoomSliderDiv.width(), 9); // IE bar width is reported as 0 so insure there's a reasonable offset here
    var leftOffset = -Math.ceil((hWidth - barWidth) / 2);

    var jHandle = jZoomSliderDiv.find('.ui-slider-handle'); // set the width of the slider handle
    jHandle.css({'left': leftOffset + 'px'});

    zoomContainer.appendChild(jZoomSliderDiv[0]); // place the zoom slider div in the vp

    isLoaded = true;
    self.update(); // update the text and position of the zoom slider handle
    self.show(true); // show/hide according to user preferences

    bindEvents_(); // add event handlers

    // ..................................................
    // closure functions
    // ............................................ bindEvents_()
    // bindEvents_ - This function adds the zoom slider control event handlers.
    //
    //    Note that by using the same namespace as the viewport when the
    //    viewport removes its events by namespace, these are also removed.

    function bindEvents_ () {
      var namespace = viewport.eventNameSpaceGet();

      viewport.renderer.addLayer({
        zoomChange () {
          if (!isActive) {
            self.update();
          }
        }
      });

      // show/hide zoom slider
      $(us.idHashROOT).on(us.evIMAGESELECTED + namespace, function (e, parms) {
        self.show(parms.uScopeIdx == viewport.getImageIdx());
      });

      // user preference update
      $(us.idHashROOT).on(us.evUSERPREFSREADY + namespace, function (e, parms) {
        self.show(userPrefs[us.clsDIVZOOMSLIDER]);
      });
      $(us.idHashROOT).on(us.evUSERPREFSET + namespace, function (e, parms) { // parms: {className: STR, value: bool}
        if (parms.className === us.clsDIVZOOMSLIDER) {
          self.show(parms.value);
        }
      });

      // mouse, ...
      jZoomSliderDiv.on('mousedown' + namespace, function (e) {
        return false; // prevent propagation to VP
      });
      jZoomSliderDiv.on('mouseleave' + namespace, function (e) {
        return false; // prevent propagation to VP
      });
      jZoomSliderDiv.on('mousemove' + namespace + ' mouseup' + namespace, function (e) {
        return true; // propagate necessary for slider operation
      });
    }
  };
    // ............................................ update() local
    //    This function updates the text and position of the zoom slider handle.
    //        magValue: optional, if passed used as the magnfication value, otherwise the current view magnification is used
  this.update = function (magValue) {
    if (us.ENABLEZOOMSLIDER == false) return;
    if (jZoomSliderDiv === undefined) return;
    var mag = (magValue) || viewport.getViewMag();

    var jHandle = jZoomSliderDiv.find('.ui-slider-handle'); // set the mag on the slider handle
    jHandle.text(mag + 'x');

    var maxVal = $(jZoomSliderDiv).slider('option', 'max'); // and position the handle along the slider
    var value = sliderMagToVal_(maxVal, mag);
    $(jZoomSliderDiv).slider('value', value);
  };
  // ............................................ sliderMagToVal_() local
  //    This function converts a passed magnification to the zoom slider's value.
  var sliderMagToVal_ = function (maxVal, mag) {
    var value = Math.ceil(maxVal * Math.sqrt(mag / viewport.getMaximumMag()));
    value = maxVal - value;
    return value;
  };
    // ............................................ sliderValToZoom_() local
    //    This function converts the current zoom slider value to its zoom.
  var sliderValToZoom_ = function (maxVal, value) {
    value = maxVal - value;
    if (value > maxVal - 2) {
      // this control has a hard time reaching 0 (so when reversed it doesn't reach max)
      value = maxVal;
    }

    // compute the magnification for this slider position
    var mag = ((value / maxVal) * (value / maxVal) * viewport.getMaximumMag()).toFixed(1);
    if (mag < viewport.getFitMag()) {
      mag = viewport.getFitMag();
    }
    if (mag > viewport.getMaximumMag()) {
      mag = viewport.getMaximumMag();
    }
    return viewport.convertToZoom(mag);
  };

    // ............................................ construction
  construct_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/zoom/zoom-slider-control.js